// Sprint 1 — Onboarding post-registro
import { useState } from "react";
import { css, cx } from "styled-system/css";
import { cf } from "@/components/brand/sfturnos-styles";
import { useOnboardingWizard } from "@/context/onboarding-wizard-context";

type Props = {
  onFinish: () => Promise<void>;
};

export function OnboardingStepAnticipation({ onFinish }: Props) {
  const { state, dispatch } = useOnboardingWizard();
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);
  const h = state.anticipationHours;
  const exampleCutoffH = Math.max(0, 19 - h);
  const exampleLabel = `${String(exampleCutoffH).padStart(2, "0")}:00`;

  async function handleClick() {
    setErr(null);
    setBusy(true);
    try {
      await onFinish();
    } catch (e) {
      setErr(e instanceof Error ? e.message : "No se pudo guardar");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div>
      <h1 className={css({ fontSize: "2xl", fontWeight: "bold", color: "#0f172a", mb: "2" })}>
        Llegamos al último paso.
      </h1>
      <p className={css({ fontSize: "sm", color: "#64748b", mb: "8", maxW: "42rem", lineHeight: 1.6 })}>
        Vamos a prevenir reprogramaciones de último momento. (La regla exacta la vas a poder afinar después en
        Configuración → Comportamiento.)
      </p>

      <label className={css({ display: "block", maxW: "28rem", mb: "4" })}>
        <span className={css({ fontSize: "sm", fontWeight: "medium", color: "#334155", display: "block", mb: "2" })}>
          ¿Con cuántas horas de anticipación mínima podrá reprogramar su turno un cliente?
        </span>
        <input
          type="number"
          min={0}
          max={168}
          value={h}
          onChange={(e) => dispatch({ type: "SET_FIELD", field: "anticipationHours", value: Number(e.target.value) || 0 })}
          className={cf.input}
        />
        <span className={css({ fontSize: "xs", color: "#64748b", mt: "1.5", display: "block", lineHeight: 1.5 })}>
          Con una anticipación mínima de 4 horas, un turno para las 19:00 podrá reprogramarse hasta antes de las 15:00.
          Con {h} horas, el ejemplo sería antes de las {exampleLabel} para un turno a las 19:00.
        </span>
      </label>

      {err ? (
        <p className={css({ fontSize: "sm", color: "#b91c1c", mb: "4" })}>{err}</p>
      ) : null}

      <button
        type="button"
        disabled={busy}
        onClick={() => void handleClick()}
        className={cx(
          cf.linkPrimaryOnDark,
          css({
            px: "6",
            py: "3",
            border: "none",
            fontSize: "sm",
            cursor: busy ? "wait" : "pointer",
            opacity: busy ? 0.75 : 1,
            bg: "linear-gradient(90deg, token(colors.brand.600), token(colors.brand.500))",
          }),
        )}
      >
        {busy ? "Guardando…" : "Continuar"}
      </button>
    </div>
  );
}
